export default __webpack_public_path__ + "static/media/basketball.1becc594.svg";